document.addEventListener(
  'contextmenu',
  (event) => {
    event.preventDefault();
  },
  { capture: true },
);

document.addEventListener(
  'keydown',
  (event) => {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
      event.preventDefault();
    }
  },
  { capture: true },
);

document.addEventListener(
  'dragstart',
  (event) => {
    if (event.target instanceof Element && event.target.closest('img, picture')) {
      event.preventDefault();
    }
  },
  { capture: true },
);
